<template>
    <div>
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.retend.specification-configuration.number-of-parts')}}:</div>
        <div class="a-form-field" :class="{ 'a-input-group--error': $v.retend.numberOfParts.$anyError }" v-if="canEditRetend">
          <input class="a-input a-input--w-140" v-model.number="retend.numberOfParts" @blur="onNumberOfPartsChanged">
        </div>
        <p v-else>{{retend.numberOfParts}}</p>
      </div>
      <div class="a-container-form ">
        <div class="a-label a-label--w-280">{{$t('form.retend.specification-configuration.make-the-following-fields-are-editable')}}:</div>
      </div>
      <div class="a-container-checkbox-group">
        <div class="a-checkbox" v-for="(options, idx) in retend.allowOptions">
          <label class="a-checkbox__label">
            <input class="a-checkbox__input" type="checkbox" v-model="options.duration" :disabled="!canEditRetend" @change="saveForm">
            <span class="a-checkbox__icon"></span>
            <span class="a-checkbox__text" v-if="idx === 0">
              {{$t('form.retend.specification-configuration.days-before-prepayment')}}
            </span>
            <span class="a-checkbox__text" v-else>
              {{$t('form.retend.specification-configuration.days-before-payment-n', {id: idx + 1})}}
            </span>
          </label>
          <label class="a-checkbox__label">
            <input class="a-checkbox__input" type="checkbox" v-model="options.percent" :disabled="!canEditRetend" @change="saveForm">
            <span class="a-checkbox__icon"></span>
            <span class="a-checkbox__text" v-if="idx === 0">
              {{$t('form.retend.specification-configuration.prepayment-percent')}}
            </span>
            <span class="a-checkbox__text" v-else>
              {{$t('form.retend.specification-configuration.payment-percent', {id: idx + 1})}}
            </span>
          </label>
          <label class="a-checkbox__label">
            <input class="a-checkbox__input" type="checkbox" v-model="options.price" :disabled="!canEditRetend" @change="saveForm">
            <span class="a-checkbox__icon"></span>
            <span class="a-checkbox__text" v-if="idx === 0">
              {{$t('form.retend.specification-configuration.prepayment-amount')}}
            </span>
            <span class="a-checkbox__text" v-else>
              {{$t('form.retend.specification-configuration.payment-amount', {id: idx + 1})}}
            </span>
          </label>
        </div>
      </div>
    </div>
</template>

<script>
  import _ from 'lodash'
  import Currency from '@/api/types/currency'
  import { numeric } from '@/validators'
  import CommonMixins from '../mixins/common'
  import PermissionsMixins from '../mixins/permissions'

  export default {
    props: {
      retend: Object,
      lot: Object
    },

    mixins: [
      CommonMixins,
      PermissionsMixins
    ],

    validations: {
      retend: {
        numberOfParts: {
          numeric,
          greaterThenLot(value) {

            return +value >= this.lot.numberOfParts
          }
        }
      }
    },

    methods: {
      async onNumberOfPartsChanged() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return
        }

        if (this.retend.numberOfParts > this.retend.parts.length) {
          Array.from({length: this.retend.numberOfParts - this.retend.parts.length}).map((v,k) => {
            this.retend.parts.push({
              part: this.retend.parts.length + 1,
              currency: new Currency(),
              deliveryDate: undefined,
              acceptingDate: undefined,
            })
          });
        }
        else if (this.retend.numberOfParts < this.retend.parts.length) {
          this.retend.parts = this.retend.parts.slice(0, this.retend.numberOfParts);
        }

        if (this.retend.numberOfParts > this.retend.checkDates.length) {
          Array.from({length: this.retend.numberOfParts - this.retend.checkDates.length}).map((v,k) => {
            this.retend.checkDates.push(false);
            this.retend.dates.push(0);
          });
        }
        else if (this.retend.numberOfParts < this.retend.parts.length) {
          this.retend.checkDates = this.retend.checkDates.slice(0, this.retend.numberOfParts);
          this.retend.dates = this.retend.dates.slice(0, this.retend.numberOfParts);
        }

        this.retend.specs.map(p => {
          if (this.retend.numberOfParts > p.parts.length) {
            Array.from({length: this.retend.numberOfParts - p.parts.length}).map((v,k) => {
              p.parts.push(0);
            });
          }
          else if (this.retend.numberOfParts < p.parts.length) {
            p.parts = p.parts.slice(0, this.retend.numberOfParts);
          }
        });

        await this.saveForm();
      }
    }
  }
</script>

<style scoped>

</style>
